import { CatExpertRouterLink } from '../../app-routing-enum';



const tabDetails = [
  {
    heading: "STUDIO.ALL",
    key: "all",
  },
  {
    heading: "STUDIO.PLANOGRAM",
    key: "planogram",
  },
  {
    heading: "STUDIO.ASSORTMENT",
    key: "assortment",
  },
];

export const experimentTabHeadDetails = {
  [CatExpertRouterLink.Studio]: {
    title: "STUDIO.EXPERIMENTS",
    tabDetails,
  },
  [CatExpertRouterLink.Experiments]: {
    title: "STUDIO.MY_EXPERIMENTS",
    tabDetails,
  },
  [CatExpertRouterLink.Shared]: {
    title: "STUDIO.SHARED",
    tabDetails,
  },
  [CatExpertRouterLink.Published]: {
    title: "STUDIO.PUBLISHED",
    tabDetails
  }
};

export const confirmDialogContent = {
  head: "STUDIO.DELETE_EXPERIMENT",
  description: "STUDIO.DELETE_CONFIRM_MSG",
  description_text: "STUDIO.DELETE_PERMANENT_MSG",
  btnCancel: "STUDIO.CANCEL",
  btnProceed: "STUDIO.DELETE_ACTION",
  btnProceedClass: "delete",
  showConfirmDialog: false,
  hasMultiple: false,
  styleClass: "confirm-dialog",
  dialogkey: "delete"
};

export const newFolderDialogContent = {
  head: "STUDIO.CREATE_NEW_FOLDER",
  folderLocation: "",
  btnCancel: "STUDIO.CANCEL",
  btnProceed: "STUDIO.ADD",
  btnProceedClass: "delete",
  showFolderDialog: false,
  styleClass: "new-folder-dialog",
  dialogkey: "delete",
  formField: [
    {
      label: "STUDIO.FOLDER_NAME",
      placeholder: "STUDIO.ENTER_NAME",
      type: "text",
      model: "name",
      isRequired: true,
      maxLength: 50,
      errors: [
        {
          key: "required",
          message: "STUDIO.PLEASE_ENTER_FOLDER_NAME",
        },
        {
          key: "maxlength",
          message: "STUDIO.MAX_50_CHARS",
        },
      ],
    },
  ],
};

export const moveExperimentFolderDialogContent = {
  title: "STUDIO.MOVE_ITEMS",
  showMoveDialog: false,
  hasMultiple: false,
  tabDetails: [
    {
      heading: "STUDIO.MY_EXPERIMENTS",
      key: CatExpertRouterLink.Experiments,
    },
    {
      heading: "STUDIO.SHARED",
      key: CatExpertRouterLink.Shared,
    },
  ],
  folderLocation: [],
  styleClass: "move-dialog",
  btnCancel: "STUDIO.CANCEL",
  btnProceed: "STUDIO.MOVE_HERE",
};

export const locationBrowseDialogContent = {
  title: "STUDIO.SELECT_LOCATION",
  showMoveDialog: false,
  hasMultiple: false,
  selectedRowData: { id: null, folder_id: null, parent_id: null },
  tabDetails: [
    {
      heading: "STUDIO.MY_EXPERIMENTS",
      key: CatExpertRouterLink.Experiments,
    },
  ],
  folderLocation: [],
  styleClass: "move-dialog",
  btnCancel: "STUDIO.CANCEL",
  btnProceed: "STUDIO.SELECT",
};

export const bulkPlanConfirmDialogContent = {
  head: "GOLDENRULES.HEAD",
  description: "GOLDENRULES.DESCRIPTION",
  btnCancel: "GOLDENRULES.BTN_CANCEL",
  btnProceed: "GOLDENRULES.BTN_PROCEED",
  showConfirmDialog: true,
  styleClass: "confirm-dialog"
};

